export const debug = true;
export const API_URL = process.env.REACT_APP_MAIN_API_URL;
export const MEDIA_URL = process.env.REACT_APP_MAIN_URL;
export const METHOD_POST = 'POST';
export const METHOD_PATCH = 'PATCH';
export const METHOD_DELETE = 'DELETE';
export const METHOD_PUT = 'PUT';
